<template lang="pug">
  div.lmm-content-body-padded
    sub-header
    b-container(fluid)
      b-row
        b-card.w-100(no-body)
          b-container(slot="header", fluid)
            b-row
              b-col(cols="2")
                datepicker(
                  :value="range.start",
                  :bootstrap-styling="true",
                  format="yyyy-MM-dd",
                  :language="range.lang",
                  @selected="startDateChanged")
              b-col(cols="2")
                datepicker(
                  :value="range.end",
                  :bootstrap-styling="true",
                  format="yyyy-MM-dd",
                  :language="range.lang",
                  :disabledDates="range.disabledDates",
                  @selected="endDateChanged")
              b-col(cols="2")
                b-form-select(v-model="filter.key" :options="filter.options", size="sm", @change="keyChangeHandler")
              b-col(cols="2")
                b-form-input(v-model="filter.value" placeholder="장치명을 입력하세요", size="sm", @keydown.enter="tableRefresh", :disabled="filter.key === 'device_alias' ? false : ''")
              b-col(cols="2")
                b-button(size="sm", @click="tableRefresh") {{$t('search')}}
              //b-col.ml-auto.text-right(cols="2")
                b-button(size="sm", variant="info", @click="") EXCEL

          b-table(
            ref="approvalTable",
            :fields="fields",
            :items="approvalStatus",
            :current-page="page.current",
            :per-page="page.per",
            :empty-text="$t('no-content')",
            tbody-class="lmm-table-body",
            sort-by="phone",
            :sort-desc="false",
            show-empty)

            //- template(v-slot:cell(pk)="row")
            //-   |{{row.item.pk}}
            template(v-slot:cell(device_alias)="row")
              |{{row.item.device_alias}}
            template(v-slot:cell(device_pub_ip)="row")
              |{{row.item.device_pub_ip}}
            template(v-slot:cell(proposal_time)="row")
              |{{row.item.proposal_time| moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
            template(v-slot:cell(start_time)="row")
              //- |{{row.item.start_time| moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
              |{{row.item.start_time| moment('add', AppState.Info.timezoneOffsetLocal, AppState.Info.dateFmt + ' HH:mm:ss')}}
              br
              //- |{{row.item.end_time| moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
              |{{row.item.end_time| moment('add', AppState.Info.timezoneOffsetLocal, AppState.Info.dateFmt + ' HH:mm:ss')}}
            template(v-slot:cell(approver_name)="row")
              |{{row.item.approver_name}} ({{row.item.approver_id}})
            template(v-slot:cell(approve_state)="row")
              b-btn(variant="link" @click="approvalPopup(row.item.approve_state, row.item.pk)")
                template(v-if="row.item.approve_state === 0")
                  |진행중
                template(v-else-if="row.item.approve_state === 1")
                  |반려
                template(v-else-if="row.item.approve_state === 2")
                  |승인완료
                template(v-else)
                  //- row.item.approve_state === 4
                  |장치삭제

          div.d-flex.justify-content-between(slot="footer")
            div
              b-form-select(
                size="sm",
                v-model="page.per",
                :options="page.perOptions")
            b-pagination(
              size="sm",
              :total-rows="page.total",
              :per-page="page.per",
              v-model="page.current",
              class="my-0 float-right"
            )  
</template>

<script>
import {ApprovalsAPI} from '../../api'
import _ from 'lodash'
import moment from 'moment'
import {getCurrentLanguage} from '@/i18n'
import * as datePickerLocale from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'access-user-component',
  components: { Datepicker },
  methods: {
    async approvalStatus (ctx) {
      this.pageMounted = false
      let params = {
        by: 'proposal_time',
        start_date: moment(this.range.start).format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment(this.range.end).format('YYYY-MM-DD HH:mm:ss'),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: 'desc',
        export_id: 'approvalsTable'
      }
      if (this.filter.key || this.filter.key === 0) {  
        if (this.filter.key === 'device_alias') {
          params.search_key = this.filter.key
          params.search_value = this.filter.value
        } else {
          params.search_key = 'approve_state'
          params.search_value = this.filter.key
        }
      }
      const resp=await ApprovalsAPI.get('', {params})
      this.page.total = resp.data.meta.total_count
      this.requestInfo = resp.data.objects

      return resp.data.objects
    },
    approvalPopup (state, item) {
      let params = {
        context: {path: 'reset_n', args: {v: 'OTP'}},
        submit: {
          size: 'md',
          color: 'primary',
          text: 'approval-submit-user',
          sort: ''
        },
        requestInfo: this.requestInfo,
        approvePK: item
      }
      if (state === 0) {
        params.submit.sort = 'ing'
      }else if (state === 1) {
        params.submit.sort = 'reject'
      }else if (state === 2) {
        params.submit.sort = 'renew'
      }else {
        params.submit.sort = 'renew'
      }
      this.AppState.$emit('show-approval-request-dialog', params, (key, data) => {
        if (key === 'submit') {
          let params = data
          ApprovalsAPI.post('', params)
            .then(resp => {
              this.$refs.approvalTable.refresh()
              this.$awn.success(this.$t('approval-success'))
            })
        }
      })
    },
    keyChangeHandler () {
      this.filter.value = ''
    },
    startDateChanged (date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged (date) {
      this.range.end = date
    },
    tableRefresh () {
      this.page.current = 1
      this.$refs.approvalTable.refresh()
    }
  },
  data () {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      range: {
        start: (new Date().setDate(-1)),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()]
      },
      fields: [
        // { key: 'pk', label: this.$t('access-num'), sortable: false },
        { key: 'device_alias', label: this.$t('device-name'), sortable: false },
        { key: 'device_pub_ip', label: this.$t('device-ip'), sortable: false },
        { key: 'proposal_time', label: this.$t('application-date'), sortable: false },
        { key: 'start_time', label: this.$t('application-period'), sortable: false },
        { key: 'approver_name', label: this.$t('approver'), sortable: false },
        { key: 'approve_state', label: this.$t('approval-status'), sortable: false }
      ],
      requestInfo: [],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      },
      filter: {
        key: 'device_alias',
        value: '',
        options: [
          // { text: this.$t('please_select'), value: '' },
          { text: this.$t('device-name'), value: 'device_alias' },
          { text: this.$t('approval-ing'), value: 0 },
          { text: this.$t('reject-submit'), value: 1 },
          { text: this.$t('at.approved'), value: 2 }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
